import { Controller } from "@hotwired/stimulus"
import { createConsumer } from "@rails/actioncable"

export default class extends Controller {
  static targets = ["indicator"]
  static values = { conversationId: Number, userId: Number }

  connect() {
    this._typing = false
    this._timeout = null

    this.subscription = createConsumer().subscriptions.create(
      { channel: "TypingChannel", conversation_id: this.conversationIdValue },
      {
        received: (data) => {
          if (data.user_id !== this.userIdValue) {
            this._showIndicator(data.typing)
          }
        }
      }
    )
  }

  disconnect() {
    if (this.subscription) this.subscription.unsubscribe()
    clearTimeout(this._timeout)
  }

  typing() {
    if (!this._typing) {
      this._typing = true
      this.subscription.perform("typing", { typing: true })
    }

    clearTimeout(this._timeout)
    this._timeout = setTimeout(() => {
      this._typing = false
      this.subscription.perform("typing", { typing: false })
    }, 2000)
  }

  _showIndicator(isTyping) {
    if (this.hasIndicatorTarget) {
      this.indicatorTarget.style.display = isTyping ? "flex" : "none"
    }
  }
}
